<!-- <app-button-close-dialog></app-button-close-dialog> -->
<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>Modificar</strong></h2>
<br>
<mat-dialog-content>

  <div class="position-relative">
    <ngx-spinner name="spModificarCasoUso" bdColor="rgba(255,255,255,0.8)" size="default" color=" var(--primary-color)"
      type="ball-atom" [fullScreen]="false">
    </ngx-spinner>
    <form [formGroup]="form">
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6">
          <mat-form-field appearance="outline">
            <input placeholder="Descripción" type="text" formControlName="Descripcion" matInput />
            <mat-error *ngIf="f.Descripcion.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <mat-form-field appearance="outline">
            <input placeholder="Icono" type="text" matTooltip="Use nombre de font-awesome" formControlName="Icono"
              matInput />
            <mat-error *ngIf="f.Icono.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <mat-form-field appearance="outline">
            <input formControlName="Path" placeholder="Path" type="text" matInput />
          </mat-form-field>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="100" name="spBusquedaMenu" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Menu</mat-label>
            <mat-select placeholder="Seleccione opcion" formControlName="Menu">
              <mat-option [value]="menu.id" *ngFor="
                    let menu of menus;
                    let i = index;
                    trackBy: trackByItems
                  ">
                {{ menu.descripcion }}</mat-option>
            </mat-select>
            <mat-error *ngIf="f.Menu.errors?.required">Este campo es <strong>requerido</strong>.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col"></div>
      </div>
    </form>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-save [disabled]="!form.valid" [isDialogClose]="true" (saveClicked)="guardar()"
    *appRoles="['Perfiles.Modificar']" (cancelClicked)="cancelar()"></app-button-save>

</mat-dialog-actions>
